import { faPersonCircleCheck, faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, CardContent, Stack, Typography } from '@mui/material';
import { MprcCard } from 'components';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router";
import { KnowledgePaths } from 'routes/KnowledgeRouter';
import { RootPaths } from 'routes/RootRouter';

////////////////////////////////////////////////////////////////////////////////

export const HomeWelcome = () => {
    const { t } = useTranslation("core");

    return (
        <Stack direction="row" justifyContent="center">
            <Box width={680} >
                <MprcCard paperColor="notice" elevation={8}>
                    <Box sx={{ p: 3 }}>
                        <Typography variant="h1" component="div">
                            {t("Home.Welcome.Title")}
                        </Typography>

                        <Typography variant="subtitle1" component="div">
                            {t("Home.Welcome.SubtitleL1")}
                            <br />
                            {t("Home.Welcome.SubtitleL2")}
                        </Typography>

                        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
                            <Link to={RootPaths.EditSelfProfile}>
                                <MprcCard>
                                    <CardContent>
                                        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="start" >
                                            <FontAwesomeIcon icon={faPersonCircleCheck} size="2x" />
                                            <div>
                                                <Typography variant="overline" component="div">
                                                    {t("Home.Welcome.ProfileHeaderText")}
                                                </Typography>
                                                <Typography variant="caption" component="div">
                                                    {t("Home.Welcome.ProfileDescriptionText")}
                                                </Typography>
                                            </div>
                                        </Stack>
                                    </CardContent>
                                </MprcCard>
                            </Link>

                            <Link to={KnowledgePaths.Subcriptions}>
                                <MprcCard>
                                    <CardContent>
                                        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="start">
                                            <FontAwesomeIcon icon={faSparkles} size="2x" />
                                            <div>
                                                <Typography variant="overline" component="div">
                                                    {t("Home.Welcome.InterestsHeaderText")}
                                                </Typography>
                                                <Typography variant="caption" component="div">
                                                    {t("Home.Welcome.InterestsDescriptionText")}
                                                </Typography>
                                            </div>
                                        </Stack>
                                    </CardContent>
                                </MprcCard>
                            </Link>
                        </Stack>
                    </Box>
                </MprcCard>
            </Box>
        </Stack>
    );
};
